
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-light pt-20">
      <div className="text-center max-w-md mx-auto p-8 bg-white/80 backdrop-blur-sm rounded-xl shadow-lg">
        <div className="inline-block mb-4 p-3 bg-navteal/10 rounded-full">
          <svg className="w-10 h-10 text-navteal" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <h1 className="text-4xl font-bold mb-4 text-navteal">Coming Soon</h1>
        <p className="text-lg text-gray-600 mb-6">
          This page is currently under development and will be available soon.
        </p>
        <a 
          href="/" 
          className="inline-block py-3 px-6 bg-glowingTeal text-white rounded-md font-medium transition-all duration-300 hover:bg-glowingTeal/90">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
